import React, { useMemo } from 'react';
import { Headline3 } from 'venn-ui-kit';
import { useHasFF } from 'venn-utils';
import { DataUploaderMode } from '../types';
import FlatSampleCard from './FlatSampleCard';
import {
  SampleHistoricalPortfoliosData,
  SampleNavData,
  SamplePortfolioData,
  SamplePrivatesData,
  SampleReturnsData,
  StrategyEnforcementSampleHistoricalPortfoliosData,
  StrategyEnforcementSamplePortfolioData,
  StrategyEnforcementTaxAnalysisSampleData,
  TaxAnalysisSampleData,
} from './CombinedSampleData';

const getSampleList = (
  mode: DataUploaderMode,
  hasHistoricals: boolean,
  hasStrategyEnforcement: boolean,
  hasTaxImpact: boolean,
) => {
  switch (mode) {
    case DataUploaderMode.NewNavs:
      return SampleNavData;
    case DataUploaderMode.Privates:
      return SamplePrivatesData;
    case DataUploaderMode.Portfolios:
      if (hasStrategyEnforcement) {
        return hasHistoricals
          ? [
              ...StrategyEnforcementSamplePortfolioData,
              ...StrategyEnforcementSampleHistoricalPortfoliosData,
              ...(hasTaxImpact ? StrategyEnforcementTaxAnalysisSampleData : []),
            ]
          : [
              ...StrategyEnforcementSamplePortfolioData,
              ...(hasTaxImpact ? StrategyEnforcementTaxAnalysisSampleData : []),
            ];
      }
      return hasHistoricals
        ? [...SamplePortfolioData, ...SampleHistoricalPortfoliosData, ...(hasTaxImpact ? TaxAnalysisSampleData : [])]
        : [...SamplePortfolioData, ...(hasTaxImpact ? TaxAnalysisSampleData : [])];
    default:
      return SampleReturnsData;
  }
};

const FlatDataGallery = ({ mode }: { mode: DataUploaderMode }) => {
  const hasHistoricals = useHasFF('historical_portfolios_ff');
  const hasStrategyEnforcement = useHasFF('rcm_strategy_enforcement_ff');
  const hasTaxImpact = useHasFF('tax_impact_ff');
  const samples = useMemo(
    () => getSampleList(mode, hasHistoricals, hasStrategyEnforcement, hasTaxImpact),
    [hasHistoricals, mode, hasStrategyEnforcement, hasTaxImpact],
  );

  return (
    <div className="relative w-full h-full" data-testid="flat-data-gallery">
      <div className="absolute left-0 right-0 top-0 bottom-0 pt-[16px] px-6 pb-[16px] overflow-y-auto">
        {mode === DataUploaderMode.Privates && <Headline3>Download one of the two Excel templates below:</Headline3>}
        {samples.map((sample) => (
          <FlatSampleCard sample={sample} key={sample.title} mode={mode} />
        ))}
      </div>
    </div>
  );
};

export default FlatDataGallery;
